import React, {
  forwardRef,
  DetailedHTMLProps,
  HTMLAttributes,
} from "react";
import './Card.css'
// Card (div)
// type CardProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
type CardProps =
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    disableHover?: boolean;
  };
// const Card = forwardRef<HTMLDivElement, CardProps>(({ className = "", ...props }, ref) => (
//   <div ref={ref} className={`card ${className}`.trim()} {...props} />
// ));
const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ className = "", disableHover = false, ...props }, ref) => (
    <div
      ref={ref}
      className={[
        "card",
        disableHover ? "card--no-hover" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      {...props}
    />
  )
);
Card.displayName = "Card";

// CardHeader (div)
type CardHeaderProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
const CardHeader = forwardRef<HTMLDivElement, CardHeaderProps>(({ className = "", ...props }, ref) => (
  <div ref={ref} className={`card-header ${className}`.trim()} {...props} />
));
CardHeader.displayName = "CardHeader";

// CardTitle (h3)
type CardTitleProps = DetailedHTMLProps<HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement>;
const CardTitle = forwardRef<HTMLHeadingElement, CardTitleProps>(({ className = "", ...props }, ref) => (
  <h3 ref={ref} className={`card-title ${className}`.trim()} {...props} />
));
CardTitle.displayName = "CardTitle";

// CardDescription (p)
type CardDescriptionProps = DetailedHTMLProps<HTMLAttributes<HTMLParagraphElement>, HTMLParagraphElement>;
const CardDescription = forwardRef<HTMLParagraphElement, CardDescriptionProps>(({ className = "", ...props }, ref) => (
  <p ref={ref} className={`card-description ${className}`.trim()} {...props} />
));
CardDescription.displayName = "CardDescription";

// CardContent (div)
type CardContentProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
const CardContent = forwardRef<HTMLDivElement, CardContentProps>(({ className = "", ...props }, ref) => (
  <div ref={ref} className={`card-content ${className}`.trim()} {...props} />
));
CardContent.displayName = "CardContent";

// CardFooter (div)
type CardFooterProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
const CardFooter = forwardRef<HTMLDivElement, CardFooterProps>(({ className = "", ...props }, ref) => (
  <div ref={ref} className={`card-footer ${className}`.trim()} {...props} />
));
CardFooter.displayName = "CardFooter";

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardDescription,
  CardContent
};
